import { notifyIntelliWriterAuthBridge } from "./intelliWriterAuthBridge";

export function logoutNotificationToExt() {
  const CE_LOGOUT = "CE_LOGOUT";
  const message = {
    type: CE_LOGOUT,
  };

  window.postMessage(message, window.location.origin);
  notifyIntelliWriterAuthBridge(message);
}
